module.exports = __webpack_public_path__ + "static/media/nofeedsimg.020b1366.svg";